import React from 'react';
import Page from '../../../Components/Containers/Page';
import TopBar from '../../../Components/TopBar';
import Tabs, { Tab } from '../../../Components/Containers/Tabs/Tabs';
import Form, { Actions, AllowedTimes, Settings, parseSettingsToData } from '../../../Components/Form';
import { customerNotificationSettings, quoteNotificationSettings, useSettings } from '../../../Data/Settings';

const Notifications = () => {
    const {settings, update} = useSettings('/notifications/settings');

    const makeSetting = (name) => settings ? {name, label: getLabel(settings, name)} : null;

    return <>
        <TopBar left="BackBtn" title="Notifications" />

        <Page>
            <div className="prose">
                <p>
                    With getSoapy your customers can be sent notifications automatically for different reasons, for example when you mark their job as done.
                </p>
                <p>
                    Email notifications are free, but SMS notifications use credits.
                </p>
            </div>
            <Tabs>
                <Tab title="Customers">
                    <CustomerSettings {...{settings, update, makeSetting}} />
                </Tab>
                <Tab title="Quotes">
                    <QuoteSettings {...{settings, update, makeSetting}} />
                </Tab>
                <Tab title="Options">
                    <OptionsSettings {...{settings, update, makeSetting}} />
                </Tab>
            </Tabs>
        </Page>
    </>
}

const getLabel = (settings, name) => {
    const setting = settings.find(setting => setting.key === name);
    return setting ? setting.label : name;
}

const CustomerSettings = ({settings, update, makeSetting}) => {
    return <Form data={parseSettingsToData(settings)} waitForData onSubmit={update}>

        <Settings settings={settings} filter={customerNotificationSettings} />

        <Actions submit={{label: 'Save'}} />
    </Form>
}

const QuoteSettings = ({settings, update, makeSetting}) => {
    return <Form data={parseSettingsToData(settings)} waitForData onSubmit={update}>

        <Settings settings={settings} filter={quoteNotificationSettings} />

        <Actions submit={{label: 'Save'}} />
    </Form>
}

const OptionsSettings = ({settings, update, makeSetting}) => {
    return <Form data={parseSettingsToData(settings)} waitForData onSubmit={update}>
        <AllowedTimes name="Notifications:AllowedTimes"
            label="Allowed times"
            innerLabel="Limit notification delivery times"
            help={val => val === null ?
                'Customers will be sent notifications immediately' :
                `Notifications sent after ${val.latest} will be delayed until ${val.earliest} the next day`
            }
        />
        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default Notifications;
